import template from "./markdown-editor.html";
import "./markdown-editor.less";
import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import Underline from "@tiptap/extension-underline";
import marked from "marked";
import TurndownService from "turndown";

const turndown = new TurndownService({
	headingStyle: "atx",
	codeBlockStyle: "fenced"
});

function controller($element, $scope, $timeout) {
	const ctrl = this;
	let editor = null;
	let skipNextUpdate = false;

	ctrl.$onInit = () => {
		$timeout(() => {
			const editorElement = $element[0].querySelector(".tiptap-editor-content");
			if(!editorElement) {
				return;
			}

			editor = new Editor({
				element: editorElement,
				extensions: [
					StarterKit,
					Underline,
					Placeholder.configure({
						placeholder: ctrl.placeholder || "Write your content here..."
					})
				],
				content: ctrl.ngModel ? marked(ctrl.ngModel) : "",
				onUpdate: ({ editor: ed }) => {
					if(skipNextUpdate) {
						skipNextUpdate = false;
						return;
					}
					const html = ed.getHTML();
					const markdown = turndown.turndown(html);
					$scope.$apply(() => {
						ctrl.ngModel = markdown;
						if(ctrl.onChange) {
							ctrl.onChange({ value: markdown });
						}
					});
				}
			});

			ctrl.editor = editor;
		});
	};

	ctrl.$onChanges = (changes) => {
		if(changes.ngModel && editor && !changes.ngModel.isFirstChange()) {
			const currentMd = turndown.turndown(editor.getHTML());
			if(currentMd !== ctrl.ngModel) {
				skipNextUpdate = true;
				editor.commands.setContent(ctrl.ngModel ? marked(ctrl.ngModel) : "");
			}
		}
	};

	ctrl.$onDestroy = () => {
		if(editor) {
			editor.destroy();
			editor = null;
		}
	};

	ctrl.toggleBold = () => editor?.chain().focus()
		.toggleBold()
		.run();
	ctrl.toggleItalic = () => editor?.chain().focus()
		.toggleItalic()
		.run();
	ctrl.toggleUnderline = () => editor?.chain().focus()
		.toggleUnderline()
		.run();
	ctrl.toggleStrike = () => editor?.chain().focus()
		.toggleStrike()
		.run();
	ctrl.toggleHeading = (level) => editor?.chain().focus()
		.toggleHeading({ level })
		.run();
	ctrl.toggleBulletList = () => editor?.chain().focus()
		.toggleBulletList()
		.run();
	ctrl.toggleOrderedList = () => editor?.chain().focus()
		.toggleOrderedList()
		.run();
	ctrl.toggleBlockquote = () => editor?.chain().focus()
		.toggleBlockquote()
		.run();
	ctrl.toggleCodeBlock = () => editor?.chain().focus()
		.toggleCodeBlock()
		.run();
	ctrl.setHorizontalRule = () => editor?.chain().focus()
		.setHorizontalRule()
		.run();
	ctrl.undo = () => editor?.chain().focus()
		.undo()
		.run();
	ctrl.redo = () => editor?.chain().focus()
		.redo()
		.run();

	ctrl.isActive = (type, attrs) => {
		if(!editor) {
			return false;
		}
		return editor.isActive(type, attrs);
	};
}

export default angular
	.module("vesl.components.markdown-editor", [])
	.component("markdownEditor", {
		template,
		controller,
		bindings: {
			ngModel: "=",
			placeholder: "@",
			onChange: "&?"
		}
	}).name;
